import {
  USERS_ADDED,
  USERS_DELETED,
  USERS_EDITED,
  USER_CONNECTED_TO_SURFER,
  USER_SET_INFORMATIONS,
  USER_SET_LIST_INFORMATION,
  USER_SET_ROLES,
  USER_SET_TOKEN,
  USER_ADD_EVENT,
  USER_SET_LANGUAGE,
} from 'src/app/redux/redux-types';
import { PreferredLanguage, UsersTableResultType } from '../services/user-service.type';

export type UserType = { id: string; menu: number[] };
export type UserRoleType = { id: string; abbreviation: string };
export type EventType = { id: string; eventId: string; roles: UserRoleType[] };

export type StateType = {
  id: string | undefined;
  userName: string;
  name: string | undefined;
  surname: string | undefined;
  email: string | undefined;
  password: string | undefined;
  telephone: string | undefined;
  organization: string | undefined;
  userRoles: UserRoleType[];
  events: EventType[];
  isRegistered: boolean | undefined;
  token: string | undefined;
  tokenc: string | undefined;
  sessionTime: number | undefined;
  isLocalUser: boolean;
  authenticated: boolean;
  isConnectedToSurfer: boolean;
  preferredLanguage: PreferredLanguage;
};

export type ListStateType = {
  usersList: UsersTableResultType[];
};

export type ActionType =
  | {
      type: typeof USER_SET_INFORMATIONS;
      payload: UserLoginInformation;
    }
  | {
      type: typeof USER_SET_ROLES;
      payload: UserRoleType[];
    }
  | {
      type: typeof USER_SET_LIST_INFORMATION;
      payload: UsersTableResultType[];
    }
  | {
      type: typeof USERS_ADDED;
      payload: UsersTableResultType;
    }
  | {
      type: typeof USERS_EDITED;
      payload: UsersTableResultType;
    }
  | {
      type: typeof USERS_DELETED;
      payload: string;
    }
  | {
      type: typeof USER_SET_TOKEN;
      payload: UserTokenInformation;
    }
  | {
      type: typeof USER_CONNECTED_TO_SURFER;
      payload: boolean;
    }
  | {
      type: typeof USER_ADD_EVENT;
      payload: EventType;
    }
  | {
      type: typeof USER_SET_LANGUAGE;
      payload: SupportedLanguagesKey;
    };

export type UserTokenInformation = {
  token: string;
  tokenc?: string;
  tokeng?: string;
};

export const supportedLanguages = ['en', 'tr', 'ar', 'es'] as const;
export type SupportedLanguagesKey = typeof supportedLanguages[number];

export type UserLoginInformation = {
  id: string;
  userName: string;
  name: string;
  surname: string;
  email: string;
  // password: string | undefined;
  userRoles: UserRoleType[];
  events: EventType[];
  isRegistered: boolean;
  sessionTime: number;
  isLocalUser: boolean;
  preferredLanguage: PreferredLanguage;
};

export type UserListInformation = {
  id: string;
  userName: string;
  name: string;
  surname: string;
  email: string;
  // password: string;
  // passwordConfirmation: string;
  telephone: string;
  organization: string;
  // userRole: UserRoleType[];
  // event: EventType[];
  // events: EventType[];
  preferredLanguage: PreferredLanguage;
};
